import React from "react";

import StorefrontManagement from "./StorefrontManagement";


/*
|--------------------------------------------------------------------------
| STOREFRONT SETTINGS
|--------------------------------------------------------------------------
|
| Rendered as a normal tab inside /setting.
| StorefrontManagement owns branding and banner CRUD.
|
|--------------------------------------------------------------------------
*/

const StorefrontSettings =
    () => {

        return (
            <StorefrontManagement />
        );

    };


export default StorefrontSettings;
